import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import api from "@/api/api";
import type {
  UpdatePasswordFormData,
  UserUpdateFormData,
} from "@/schemas/user";
import type { User } from "@/types/api/user";

const getMe = async () => {
  const { data } = await api.get<User>("/users/me");
  return data;
};

export const useMe = () => {
  return useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    placeholderData: keepPreviousData,
  });
};

const updateMe = async (data: UserUpdateFormData) => {
  const res = await api.patch<User>("/users/me", data);
  return res.data;
};

export const useUpdateMe = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateMe,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["me"] });
    },
  });
};

const updatePassword = async (data: UpdatePasswordFormData) => {
  const res = await api.patch("/users/me/password", data);
  return res.data;
};

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: updatePassword,
  });
};
